// samples/conversions depend on the parent field's dateRanges argument.
// If these types are normalized by id, the last query overwrites the counts
// used by the sidebar (LAST_30_DAYS) and every heatmap looks active/inactive
// together.
const typePolicies = {
  MatomoHeatmap: { keyFields: false },
  MatomoSessionRecording: { keyFields: false },
  MatomoGoal: { keyFields: false },
};

module.exports = { typePolicies };
